import { render, staticRenderFns } from "./channelReport.vue?vue&type=template&id=35d0faf6&scoped=true&"
import script from "./channelReport.vue?vue&type=script&lang=js&"
export * from "./channelReport.vue?vue&type=script&lang=js&"
import style0 from "./channelReport.vue?vue&type=style&index=0&id=35d0faf6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d0faf6",
  null
  
)

export default component.exports